import * as Actions from '../../actions/vehicle/type';

const initialState = {
  createVehicleLoading: false,
  createVehicleSuccess: '',
  createVehicleError: '',

  getVehicleListLoading: false,
  vehicleList: [],
  singleVehicle: '',
  vehicleSingleLoading: false,
  error: '',
  loading: false,
  updateVehicleSuccess: '',

  deleteVehicleLoading: false,
  deletedVehicle: '',
  deleteVehicleErr: '',

  exportVehicle: '',
  count: 0,
};
export const VehicleReducer = (state = initialState, action) => {
  switch (action.type) {
    // create vehicle
    case Actions.CREATE_VEHICLE_REQUEST:
      return {
        ...state,
        createVehicleLoading: true,
      };
    case Actions.CREATE_VEHICLE_SUCCESS:
      const _vehicles = [...state.vehicleList];

      if (action.payload?.id) {
        _vehicles.push(action.payload);
      }

      return {
        ...state,
        createVehicleLoading: false,
        createVehicleSuccess: action?.payload || '',
        vehicleList: _vehicles,
        count: state?.count + 1 || 0,
      };
    case Actions.CREATE_VEHICLE_FAIL:
      return {
        ...state,
        createVehicleLoading: false,
        createVehicleError: action.payload,
      };
    case Actions.CLEAR_CREATE_VEHICLE_STATE:
      return {
        ...state,
        createVehicleLoading: false,
        createVehicleError: '',
        createVehicleSuccess: '',
      };

    // update vehicle
    case Actions.UPDATE_VEHICLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.UPDATE_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        updateVehicleSuccess: action?.payload || '',
      };
    case Actions.UPDATE_VEHICLE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // delete vehicle
    case Actions.DELETE_VEHICLE_REQUEST:
      return {
        ...state,
        deleteVehicleLoading: true,
      };
    case Actions.DELETE_VEHICLE_SUCCESS:
      return {
        ...state,
        deleteVehicleLoading: false,
        deletedVehicle: action?.payload?.data || '',
      };
    case Actions.DELETE_VEHICLE_FAIL:
      return {
        ...state,
        deleteVehicleLoading: false,
        deleteVehicleErr: action.payload,
      };

    // clear deleted vehicle state
    case Actions.CLEAR_DELETE_VEHICLE_STATE:
      return {
        ...state,
        deleteVehicleLoading: false,
        deleteVehicleErr: '',
        deletedVehicle: '',
      };

    case Actions.UPDATE_VEHICLES_LISTING:
      let vehicleList = state.vehicleList || [];

      // if user delete vehicle from list then deleted item will remove from array

      if (action?.delete) {
        vehicleList = vehicleList?.filter(
          (vhcl) => vhcl?.id !== action.payload?.id,
        );
      } else {
        // on update vehicle from listing then also update listing as well
        const updatedVehicleId = action.payload?.id || '';
        const foundIndex = vehicleList.findIndex(
          (x) => x.id === updatedVehicleId,
        );

        if (foundIndex > -1) {
          vehicleList[foundIndex] = {
            ...vehicleList[foundIndex],
            ...action.payload,
          };
        }
      }

      return {
        ...state,
        vehicleList,
        count: action?.delete ? state?.count - 1 : state?.count,
      };

    case Actions.CLEAR_UPDATE_VEHICLE_STATE:
      return {
        ...state,
        loading: false,
        error: '',
        updateVehicleSuccess: '',
      };

    // Get Vehicle listing
    case Actions.GET_VEHICLE_LISTING_REQUEST:
      return {
        ...state,
        getVehicleListLoading: true,
      };
    case Actions.GET_VEHICLE_LISTING_SUCCESS:
      return {
        ...state,
        getVehicleListLoading: false,
        vehicleList: action?.payload?.vehicles || [],
        count: action?.payload?.count || 0,
      };
    case Actions.GET_VEHICLE_LISTING_FAIL:
      return {
        ...state,
        getVehicleListLoading: false,
        error: action.payload,
      };

    // update vehicle images when when view or edit vehicle from listing
    case Actions.UPDATE_VEHICLE_IMAGES:
      const vehicles = state.vehicleList || [];

      const vehicleId = action.payload?.data?.id;

      const findInd = vehicles?.findIndex((x) => x.id === vehicleId);

      if (findInd > -1) {
        vehicles[findInd] = {
          ...vehicles[findInd],
          ...(action.payload.data || ''),
        };
      }

      return {
        ...state,
        vehicleList: [...vehicles],
      };

    // get single vehicle
    case Actions.GET_VEHICLE_REQUEST:
      return {
        ...state,
        vehicleSingleLoading: true,
      };
    case Actions.GET_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicleSingleLoading: false,
        singleVehicle: action?.payload || '',
      };
    case Actions.GET_VEHICLE_FAIL:
      return {
        ...state,
        vehicleSingleLoading: false,
        error: action.payload,
      };
    case Actions.CLEAR_GET_VEHICLE_STATE:
      return {
        ...state,
        vehicleSingleLoading: false,
        singleVehicle: '',
        error: '',
      };

    // Export Vehicle
    case Actions.EXPORT_VEHICLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.EXPORT_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        exportVehicle: action?.payload || '',
      };
    case Actions.EXPORT_VEHICLE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_EXPORT_VEHICLE_STATE:
      return {
        ...state,
        loading: false,
        error: '',
        exportVehicle: '',
      };

    // Search Vehicle
    case Actions.SEARCH_VEHICLE_REQUEST:
      return {
        ...state,
        searchVehicleLoading: true,
        searchedVehicles: [],
        searchVehicleError: '',
      };
    case Actions.SEARCH_VEHICLE_SUCCESS:
      return {
        ...state,
        searchVehicleLoading: false,
        searchedVehicles: action?.payload?.data || [],
      };
    case Actions.SEARCH_VEHICLE_FAIL:
      return {
        ...state,
        searchVehicleLoading: false,
        searchVehicleError: action.payload,
      };
    case Actions.CLEAR_SEARCH_VEHICLE_STATE:
      return {
        ...state,
        searchVehicleLoading: false,
        searchVehicleError: '',
        searchedVehicles: '',
      };
    // Import Parts

    case Actions.IMPORT_VEHICLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.IMPORT_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        importVehiclesData: action.payload,
      };
    case Actions.IMPORT_VEHICLE_FAIL:
      return {
        ...state,
        loading: false,
        importError: action.payload,
      };
    case Actions.CLEAR_IMPORT_VEHICLE_STATE:
      return {
        ...state,
        loading: false,
        importError: '',
        importVehiclesData: '',
      };

    default:
      return state;
  }
};
